<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/H3utMF/tc-custom/9781035832767.jpg?1728726136839" alt="This image is the cover for the book Dead Serious Too"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dead Serious Too
      </h1>
      <p class="bookDescription body article font2">
        <p>Would Stan’s eccentric, fun-loving disposition continue to be subdued by low self-esteem and personal insecurities? A timid child who had grown into a slightly less troubled young man, Stan was approaching his nineteenth birthday with a pledge to continue the plan he had embarked upon nine years earlier. Signs of success were emerging. Happily, Stan believed his recent experiences in both his personal and working life were far less daunting and withdrawn than he had once imagined at the age of ten. He seemed to be on the cusp of nurturing a more confident demeanour, with the potential to enrich his life in myriad ways. With perseverance, self-control, and the support of friends and family, Stan sensed his future could develop into something beyond his wildest dreams. His destiny, however, would be shaped by how he responded to the inevitable challenges along the bumpy road of his life. While he acknowledged that some unfortunate or distressing events might strike and later haunt him, his increased confidence gave him hope that such occurrences would be short-lived and interspersed with moments of humour and excitement. Ever the optimist, he dreamed of love and happiness and possibly even forming an affectionate relationship with a lifelong partner. Illustrated through separate linked novellas, narratives of Stan’s late teenage years and early adult life can be read as one continuous novel or enjoyed as individual short stories.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stewart Perkins
      </h2>
      
      <p class="authorDescription body article">Born in the East End of London in the early 1950s, the retired draughtman has witnessed and lived through many life changing social and economic developments. The sports loving man with an enjoyment of life grew up and attended schools in Dagenham. Here, living within a working-class community the novelist learned friendship, respect and trust were just as equal if not more important than money. Notorious for animatedly narrating ‘exaggerated’ tales from his youth, with a cockney wit inherited from his father he always looks for a reason to laugh.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a6125d5e